module.exports = __webpack_public_path__ + "media/large/real_estate_land_sale-7697c638.jpeg";